import { useState } from 'react'
import { Button, Icon } from '../../components/index.js'

/** "Copy" that reads "Copied" for a moment — invite links, tokens, secrets, recovery codes. */
export function CopyButton({ text, label = 'Copy', ariaLabel }: { text: string; label?: string; ariaLabel?: string }) {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      window.setTimeout(() => setCopied(false), 1800)
    } catch {
      // Clipboard access can be refused (insecure context, permissions); the
      // text is on screen to select by hand either way.
    }
  }

  return (
    <Button variant="secondary" onClick={() => void copy()} aria-label={copied ? 'Copied' : (ariaLabel ?? label)}>
      <Icon name={copied ? 'Check' : 'Copy'} size={14} />
      {copied ? 'Copied' : label}
    </Button>
  )
}
